
export default function Services() {
  const services = [
    {
      icon: 'ri-shield-check-line',
      title: '24/7 Monitoring',
      description: 'Round-the-clock professional monitoring ensures your home is always protected with immediate emergency response.',
      features: ['Instant alerts', 'Emergency dispatch', 'Mobile notifications']
    },
    {
      icon: 'ri-tools-line',
      title: 'Professional Installation',
      description: 'Expert technicians install and configure your complete security system with precision and care.',
      features: ['Same-day service', 'Full setup included', 'System training']
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Smart Home Control',
      description: 'Control your security system, cameras, and smart devices from anywhere using our mobile app.',
      features: ['iOS & Android apps', 'Voice control', 'Automation rules']
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Customer Support',
      description: 'Dedicated support team available to help with any questions or technical assistance you need.',
      features: ['24/7 availability', 'Expert guidance', 'Quick response']
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-1.5 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold mb-4">
            OUR SERVICES
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Complete Security Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Everything you need to protect your home and family with cutting-edge technology and professional service
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-14 h-14 flex items-center justify-center bg-teal-600 rounded-2xl mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 text-sm mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-teal-600"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
